import EmailInputWithBadListCheck from './EmailInputWithBadListCheck'

export default EmailInputWithBadListCheck
